module.exports = __webpack_public_path__ + "static/img/IMG_20160101_162419.00311d35.jpg";